
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#D0EFEC","fill-rule":"evenodd","d":"M43.25 24.34c0 11.618-9.417 21.037-21.035 21.037S1.178 35.958 1.178 24.34 10.597 3.304 22.215 3.304 43.25 12.723 43.25 24.341m-6.186 0c0 8.201-6.649 14.85-14.85 14.85a14.8 14.8 0 0 1-8.158-2.44l20.568-20.568a14.8 14.8 0 0 1 2.44 8.159m-6.842-12.506a14.8 14.8 0 0 0-8.007-2.343c-8.201 0-14.85 6.649-14.85 14.85 0 2.948.86 5.697 2.343 8.007z","clip-rule":"evenodd"}}),_c('path',{attrs:{"stroke":"#234652","d":"M8.367 31.657A18.061 18.061 0 0 1 36.234 9.324M39.992 14.215a18.06 18.06 0 0 1-28.763 21.167M36.852 9.236 10.614 35.475"}})])
          )
        }
      }
    